import React, { Component, Fragment} from 'react';
import {connect} from 'react-redux';
import Modal from 'react-responsive-modal';

import './Home.Module.scss';

import {cardData} from 'utilities/card';

import Card from 'components/UI/Card/Card';
import WorkshopCard from 'components/UI/WorkshopCard/WorkshopCard';
import Top from 'components/UI/Top/Top';
import FilterMenu from 'components/UI/FilterMenu/FilterMenu';
import Accordion from '../../components/UI/Accordion/Accordion';
import CardPopup from 'components/UI/CardPopup/CardPopup'

import lessonByFilter from 'selectors/lesson/lesson-by-filter';
//import fontawesome
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faBolt, faChevronLeft, faCode, faHeart, faUsers, faUser, faClock, faCut, faDownload, faArrowToBottom } from '@fortawesome/pro-solid-svg-icons';
import {faHeart as faHeartRegular,} from '@fortawesome/pro-regular-svg-icons';
import{ faTimes as faTimesLight} from '@fortawesome/pro-light-svg-icons';
/**
 * import components
 */

 import indexLesson from 'actions/lesson/index';
 import { loadExisting} from 'actions/filter';

const mapStateToProps = (state, props) => {
    return {
        lessons: lessonByFilter(state),
        originalLessons: state.lesson.entities
    };
};

const mapDispatchToProps = {
    indexLesson,
    loadExisting
};

class Home extends Component {

    constructor() {
        super();
        this.state = {
            open: false,
            cardId: null,
        }
        this.openModal  = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.parentFunctie = this.parentFunctie.bind(this);
    }

    componentDidMount() {
        this.props.indexLesson().then(() => {
            if(this.props.match.params.cardId && this.props.originalLessons.allIds.includes(this.props.match.params.cardId)){
                this.openModal(parseInt(this.props.match.params.cardId))
            }
        });

        if(this.props.match.params.cardId && this.props.originalLessons.allIds.includes(this.props.match.params.cardId)){
            this.openModal(parseInt(this.props.match.params.cardId))
        }

        if(this.props.match.url.includes('platform-filter')) {
            let filter = this.props.match.params.filter;

            let object = decodeURIComponent(filter);
            object = JSON.parse(object);
            this.props.loadExisting(object);
            this.props.history.push('/platform');
        }
    }

    componentDidUpdate(prevProps){
        if(this.props.match.params.cardId != prevProps.match.params.cardId && this.props.match.params.cardId){
            this.openModal(this.props.match.params.cardId)
        }
    }

    parentFunctie(id){
        this.props.history.push(`/platform/${id}/${this.props.originalLessons.byId[id].name.toString().split(" ").join("-").toLowerCase()}`)
    }


    
    openModal(id) {
        this.setState({
            open: true,
            cardId: id,
        });
        
        window.scrollTo(0,0)
    }

    closeModal() {
        this.setState({
            open: false
        });
        this.props.history.push(`/platform`)
        
        window.scrollTo(0,0)
    }

    render() {
        return (
            <Fragment>
                
                <Top></Top>
                    <div styleName='pagewrapper'>
                        <FilterMenu></FilterMenu>
                        <div>
                            <div styleName='wrapper-grid'>
                                
                                {
                                    this.props.lessons.map((lesson, index) => {
                                    
                                        return <div>
                                            <Card 
                                            key={index}
                                            index={index} 
                                            card={lesson} 
                                            parentFunctie={this.parentFunctie}
                                            />
                                            </div>
                                    })
                                }
                                

                                {/* modal section ------------------------------------------------------------------*/}

                                <Modal open={this.state.open} onClose={this.closeModal} styles={{
                                    modal: {
                                    padding:'0px',
                                    margin:'auto',
                                    backgroundColor:'transparent',
                                    WebkitBoxShadow: '-0px 0px 0px 0px rgba(0, 0, 0, 0)',
                                    MozBoxShadow: '-0px 0px 0px 0px rgba(0, 0, 0, 0)',
                                    boxShadow: '-0px 0px 0px 0px rgba(0, 0, 0, 0.)',
                                    width: '100%',
                                    position: 'Static',
                                    marginTop:'40px',
                                    marginBottom:'40px',
                                    },
                                    closeButton:{
                                        display:'none'
                                    },
                                    overlay:{
                                        backgroundColor:'rgba(57, 59, 81, 0.8)',
                                    }
                                    }}>
                                        <p styleName='cross5'
                                            style={{position: 'absolute', fontSize: '25px', zIndex:'100', color:'white', right:'20px', top:'15px', cursor:'pointer',margin: '0px', height:'fit-content',lineHeight:'20px' }}
                                        onClick={this.closeModal}><FontAwesomeIcon icon={faTimesLight}/></p>
                                        {this.state.cardId != null && this.props.originalLessons.byId[this.state.cardId] &&
                                            <CardPopup card={this.props.originalLessons.byId[this.state.cardId]}/>
                                        }
                                </Modal>
                            </div>
                        </div>
                    </div>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);